/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tcType: NonNullable<unknown> }} Input_Tc_Set_Button_TitleInputs */

const en_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Insert TC ${i?.tcType}`)
};

const fr_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Insérer TC ${i?.tcType}`)
};

const de_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TC ${i?.tcType} einfügen`)
};

const it_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inserisci TC ${i?.tcType}`)
};

const ru_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вставьте TC ${i?.tcType}`)
};

const es_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Insertar TC ${i?.tcType}`)
};

const zh_cn2_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`插入 TC ${i?.tcType}`)
};

const ja_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TC ${i?.tcType} を挿入`)
};

const hi_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`TC ${i?.tcType} डालें`)
};

const pt_pt2_input_tc_set_button_title = /** @type {(inputs: Input_Tc_Set_Button_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inserir TC ${i?.tcType}`)
};

/**
* | output |
* | --- |
* | "Insert TC {tcType}" |
*
* @param {Input_Tc_Set_Button_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_set_button_title = /** @type {((inputs: Input_Tc_Set_Button_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Set_Button_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_tc_set_button_title(inputs)
	if (locale === "de") return de_input_tc_set_button_title(inputs)
	if (locale === "it") return it_input_tc_set_button_title(inputs)
	if (locale === "ru") return ru_input_tc_set_button_title(inputs)
	if (locale === "es") return es_input_tc_set_button_title(inputs)
	if (locale === "zh-CN") return zh_cn2_input_tc_set_button_title(inputs)
	if (locale === "ja") return ja_input_tc_set_button_title(inputs)
	if (locale === "hi") return hi_input_tc_set_button_title(inputs)
	if (locale === "pt-PT") return pt_pt2_input_tc_set_button_title(inputs)
	return en_input_tc_set_button_title(inputs)
});